var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scenario-list-item-base", {
    class: { "active-scenario": _vm.scenario.isActive },
    attrs: { scenario: _vm.scenario },
    scopedSlots: _vm._u([
      {
        key: "bottom",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "scenario-list-item-content footer-content" },
              [
                _c("div", { staticClass: "row footer-row" }, [
                  _c("div", { staticClass: "col-12 form-group" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "dmv-text dmv-text-secondary scenario-list-item-estimate"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.resource(
                                "DmvScenarioIndexModel_MonthlyEstimate_Label"
                              )
                            ) +
                            ": \n                        \n                        "
                        ),
                        _c(
                          "span",
                          { staticClass: "scenario-list-item-estimate-number" },
                          [_vm._v(_vm._s(_vm.scenario.monthlyEstimate))]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _vm.showCheckBox
                        ? _c("scenario-list-item-checkbox", {
                            attrs: {
                              label: _vm.scenario.checkboxText,
                              value: _vm.scenario.isActive,
                              disabled: _vm.scenario.isDisabled,
                              "disabled-click-warning-message":
                                _vm.scenario.disabledReason
                            },
                            on: {
                              input: function($event) {
                                return _vm.$emit(
                                  "scenario-selection-changed",
                                  $event
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }